var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgQr(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 41,
    height: 41,
    viewBox: "0 0 41 41",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_31_322)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.6758 14.5506H0.648682V0.52356H14.6758V14.5506ZM3.78622 3.63933V11.4104H11.5572V3.63797L3.78622 3.63933Z",
    fill: "#2B1C50"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M26.616 0.51001H40.6363V14.5303H26.616V0.51001ZM29.7332 11.4132H37.5042V3.64075H29.7277L29.7332 11.4132Z",
    fill: "#2B1C50"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.655518 26.4707H14.6758V40.491H0.655518V26.4707ZM3.78624 29.6015V37.3725H11.5559V29.6015H3.78624Z",
    fill: "#565ADD"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.6416 8.31915H23.7465V14.5575H20.6416V20.4378L20.6526 20.427H17.511L17.5233 20.4378V11.454H20.6539V8.30554L20.6416 8.31915Z",
    fill: "#2B1C50"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.44409 20.4392H11.5681V17.3262H14.6865V20.4379H17.5192L17.5069 20.4269V23.5659L17.5178 23.555H8.44816V20.4242L8.44409 20.4392Z",
    fill: "#2B1C50"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M37.5356 23.5645H40.6418V31.1368H33.1553L33.1662 31.1477V28.0006H37.5453V23.5522L37.5356 23.5645Z",
    fill: "#2B1C50"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.45498 20.4269H3.77389V23.5413H0.66626V17.337H8.44958V20.4419L8.45498 20.4269Z",
    fill: "#2B1C50"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M26.9061 31.1395H20.6446L20.6554 31.1504C20.6554 30.105 20.6554 29.0614 20.6554 28.0197L20.6433 28.0306H23.7821V23.5631L23.7713 23.574H26.9019V31.1586L26.9061 31.1395Z",
    fill: "#2B1C50"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.7779 20.4433V17.337H33.1498V20.4433L33.1606 20.4324H23.7683L23.7779 20.4433Z",
    fill: "#2B1C50"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.6282 34.2948H23.7588V37.3875H26.8896V40.5087H20.6499C20.6499 38.4351 20.6499 36.3593 20.6499 34.2812L20.6282 34.2948Z",
    fill: "#2B1C50"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M33.1526 31.1395C33.1526 32.1858 33.1526 33.2321 33.1526 34.2785L33.1634 34.2676H26.9019V31.1368L26.8911 31.1477H33.1526V31.1395Z",
    fill: "#2B1C50"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.6744 5.19655V0.512695H23.7494V5.19655H20.6621H20.6744Z",
    fill: "#2B1C50"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.6526 28.0115H17.5218V23.5536L17.511 23.5645H20.6499L20.639 23.5536V28.021L20.6526 28.0115Z",
    fill: "#2B1C50"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M37.5303 20.4297C37.5303 21.476 37.5303 22.5218 37.5303 23.5672L37.5411 23.5563H33.1526L33.1636 23.5672C33.1636 22.5218 33.1636 21.4783 33.1636 20.4365L33.1526 20.4474H37.5424L37.5303 20.4297Z",
    fill: "#2B1C50"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M36.2668 37.4228H40.6444V40.4977H36.2776C36.2776 39.4782 36.2776 38.445 36.2776 37.4105L36.2668 37.4228Z",
    fill: "#2B1C50"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.654 8.3083H17.5491V5.20205H20.6676L20.6553 5.19116C20.6553 6.23384 20.6509 7.27742 20.6418 8.32191L20.654 8.3083Z",
    fill: "#2B1C50"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.6404 20.4379H23.7807L23.7697 20.427V23.5605L23.7807 23.5495H20.6417L20.6527 23.5605V20.4297L20.6404 20.4379Z",
    fill: "#2B1C50"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.6404 31.1382C20.6404 32.1899 20.6359 33.2417 20.6268 34.2934L20.6378 34.2812H17.541V31.1504H20.6514L20.6404 31.1382Z",
    fill: "#2B1C50"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M37.5411 20.4392V17.333H40.6378V20.4283H37.5303L37.5411 20.4392Z",
    fill: "#2B1C50"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M33.1499 34.2771H36.2671C36.2671 35.3321 36.2671 36.3761 36.2671 37.4215L36.2779 37.4092L33.1472 37.3929L33.158 37.4038C33.158 36.3575 33.158 35.3112 33.158 34.2649L33.1499 34.2771Z",
    fill: "#2B1C50"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M33.1527 37.3943V40.5005H30.0559V37.4052H33.1635L33.1527 37.3943Z",
    fill: "#2B1C50"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.11938 9.06646V5.98743H9.19843V9.06646H6.11938Z",
    fill: "#2B1C50"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M32.0798 9.06646V5.98743H35.1588V9.06646H32.0798Z",
    fill: "#2B1C50"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.21186 31.9521V35.0312H6.13281V31.9521H9.21186Z",
    fill: "#565ADD"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M33.1527 23.5536V26.6598H30.0559V23.5645H33.1635L33.1527 23.5536Z",
    fill: "#2B1C50"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_31_322"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    fill: "white",
    transform: "translate(0.645996 0.51001)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQr);
export default __webpack_public_path__ + "static/media/qr.bf535757eaa1d5a4463c39ab4d183385.svg";
export { ForwardRef as ReactComponent };